import moment from "moment";
import Vue from "vue";
import router from "@/router";
import _ from "lodash";
import store from "@/store";
import cookieType from "@/config/cookieType";
// import { authenticationService } from "@/services/AuthenticationService";
const userD = () => ({
  // "user_id":1,
  user_name: null,
  user_email: null,
  user_number: null,
  user_number_country_code: null,
  is_verified: null
});

function initialState() {
  return {
    paging: {},
    items: [],
    loggedUser: userD(),
    city_id: null,
    city_name: null,
    cinema_id: null,
    cinema_name: null,
    cinema_has_chefs_corner: null,
    unread_notifications_count: null
  };
}
const state = initialState();

const mutations = {
  ON_RESET_SAMPLE_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  ON_SET_USER_DETAILS: (state, payload) => {
    state.loggedUser = {
      ...userD(),
      ...payload
    };
  },
  ON_LOGOUT: (state, payload) => {
    state.loggedUser = {
      ...userD()
    };
  },
  SET_LOCATION: async (state, payload) => {
    state.city_id = payload.city_id;
    state.city_name = payload.city_name;
    state.cinema_id = null;
    state.cinema_name = null;
    Vue.cookie.set(cookieType.CITYID, payload.city_id);
    // if (router.history.current.fullPath !== `/`) {
    //   await router.push({
    //     name: "Home Page"
    //   });
    // }
    window.location.reload();
  },
  SET_COUNTRY_AND_CITY: (state, payload) => {
    state.city_id = payload.city_id;
    state.city_name = payload.city_name;
  },
  SET_CINEMA: (state, payload) => {
    console.log("payload", payload);
    state.cinema_id = payload.Cinema_strID;
    state.cinema_name = payload.Cinema_strName;
    state.cinema_has_chefs_corner = payload.cinema_has_chefs_corner;
    // window.location.reload();
  },
  SET_UNREAD_NOTIFICATION_COUNT: (state, payload) => {
    state.unread_notifications_count = payload;
  },
  SET_CINEMA_ID: (state, payload) => {
    console.log("payload cinema id", payload);
    state.cinema_id = payload.Cinema_strID;
  },
  SET_USER_PROFILE_IMAGE: (state, payload) => {
    console.log("payload", payload);
    state.loggedUser.profile_image = payload;
  }
};

const actions = {
  onResetSampleStoreState: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("ON_RESET_SAMPLE_STORE_STATE");
  },
  setUserLoggedUser: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("ON_SET_USER_DETAILS", payload);
  },
  // logoutUser: async ({ dispatch, commit, state }, { ...payload }) => {
  //     Vue.cookie.remove(cookieType.MCHASHID)
  //     await commit('ON_LOGOUT', payload);
  //     await store.dispatch('setUserLoggedStatus', false);
  // },
  setLocation: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_LOCATION", payload);
  },
  setCityAndCoutry: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_LOCATION", payload);
    window.location.reload();
  },
  setCinema: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_CINEMA", payload);
    await router.push({
      name: "Food And Drinks",
      params: { cinema_code: payload.Cinema_strID }
    });
    window.location.reload();
  },
  setCinemaID: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("SET_CINEMA_ID", payload);
  },
  setUnreadNotificationCount: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    console.log("yeahh payload", payload);
    await commit("SET_UNREAD_NOTIFICATION_COUNT", payload.count);
  },
  setUserProfileImage: async ({ dispatch, commit, state }, { ...payload }) => {
    console.log("payload", payload);
    await commit("SET_USER_PROFILE_IMAGE", payload.image);
  }
};

const getters = {
  getPersistItems: state => state.items,
  getLoggedUser: state => state.loggedUser,
  getLocation: state => state.city_name,
  getFndCinema: state => state.cinema_id,
  getFndCinemaName: state => state.cinema_name,
  getUnreadNotificationCount: state => state.unread_notifications_count,
  getFndCinema_has_chefs_corner: state => state.cinema_has_chefs_corner
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/SampleStorePersist.js